import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hourformat',
  standalone: false,
})
export class HourFormatPipe implements PipeTransform {
  transform(value: number): string {
    let hours = Math.floor(value);
    let minutes = Math.round((value % 1) * 60);
    if (minutes === 60) {
      minutes = 0;
      hours++;
    }
    return `${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
  }
}
